import _objectSpread from "/www/wwwroot/build/dev/THIS-gfast-front-pc/node_modules/@babel/runtime-corejs2/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Cookies from "js-cookie";
import _variables from "@/assets/styles/variables.scss";
import { getRouters } from "@/api/menu";
import { mapGetters } from "vuex";
export default {
  data: function data() {
    return {
      activeIndex: Cookies.get("titleIndex"),
      //所有路由导航信息
      allRouter: null
    };
  },
  computed: _objectSpread({
    theme: function theme() {
      return this.$store.state.settings.theme;
    },
    variables: function variables() {
      return _variables;
    }
  }, mapGetters(["defaultProject"])),
  beforeMount: function beforeMount() {
    this.handleSelectTo();
    window.addEventListener("resize", this.setVisibleNumber);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.setVisibleNumber);
  },
  created: function created() {
    var _this = this;
    this.$api.uploadList().then(function (res) {
      _this.$store.commit("setUploadList", res.data);
    });
  },
  // console.log(this.defaultProject)
  mounted: function mounted() {
    this.setVisibleNumber();
  },
  methods: {
    //导航菜单选择时更改
    handleSelectTo: function handleSelectTo(key, keyPath) {
      var _this2 = this;
      var keys = key == undefined ? this.activeIndex : key;
      if (key) {
        this.activeIndex = key;
        // Cookies.set("titleIndex", key);
      }
      // console.log('keys',keys)
      this.$store.dispatch("GenerateRoutess", {
        key: keys
      });
      getRouters().then(function (res) {
        // console.log({id:this.activeIndex})
        _this2.allRouter = res.data;
        if (!_this2.activeIndex) {
          var _this2$allRouter$;
          _this2.activeIndex = ((_this2$allRouter$ = _this2.allRouter[0]) === null || _this2$allRouter$ === void 0 ? void 0 : _this2$allRouter$.id) + "";
        }
        Cookies.set("titleIndex", _this2.activeIndex);
        _this2.$store.commit('SET_NAVBAR_INDEX', _this2.activeIndex);
      });
    },
    /**切换项目*/changeProject: function changeProject() {
      this.$router.push({
        path: "/project-switch/index"
      });
    },
    // 根据宽度计算设置显示栏数
    setVisibleNumber: function setVisibleNumber() {
      var width = document.body.getBoundingClientRect().width / 3;
      // this.visibleNumber = parseInt(width / 85)
    }
  }
};